import clsx from 'clsx'
import { Link } from '@tanstack/react-router'
import { useState, useMemo, ReactNode } from 'react'
import { useAuth } from '../contexts/AuthContext'
import $ from './styles.module.css'
import Logo from '@tandem/ui/Тандем.svg?react'
import Dropdown from '@tandem/ui/Dropdown'
import md5 from 'md5'
import { SidecarContext } from './sidecar'
import { Building2Icon, PackageIcon, StoreIcon, Users2Icon, UsersRoundIcon } from 'lucide-react'

export default function Layout({ children }) {
  let { user, logout, company } = useAuth()
  let userEmail = user?.email || ''
  let gravatarUrl = getGravatarUrl(userEmail)
  let isAdmin = user?.companies?.some((c: any) => c.company_id === 0 && c.role === 'admin')

  let [menuOpen, setMenuOpen] = useState(false)
  let [sidecar, setSidecar] = useState<ReactNode>(null)
  let sidecarContextValue = useMemo(() => ({ content: sidecar, setContent: setSidecar }), [sidecar])

  return (
    <SidecarContext.Provider value={sidecarContextValue}>
      <div class={$.layout}>
        
        <header class={$.header}>
          <div class={$.logoWrapper}>{/* Side elements of header have flex-grow:1 making SVG centerified w/o wrapper. */}
            <Logo class={$.logo} />
          </div>
          
          <ul class={$.nav}>
            <li>
              <Link to='/users' activeProps={{ className: $.active }} className={$.link}>
                <Users2Icon />
                <span>Пользователи</span>
              </Link>
            </li>
            <li>
              <Link to='/companies' activeProps={{ className: $.active }} className={$.link}>
                <Building2Icon />
                <span>Компании</span>
              </Link>
            </li>
            <li>
              <Link to='/catalog' activeProps={{ className: $.active }} className={$.link}>
                <PackageIcon />
                <span>Каталог</span>
              </Link>
            </li>
            <li>
              <Link to='/stores' activeProps={{ className: $.active }} className={$.link}>
                <StoreIcon />
                <span>Торговые точки</span>
              </Link>
            </li>
            <li>
              <Link to='/staff' activeProps={{ className: $.active }} className={$.link}>
                <UsersRoundIcon />
                <span>Сотрудники</span>
              </Link>
            </li>
          </ul>

          <Dropdown
            open={menuOpen}
            onOpenChange={setMenuOpen}
            align='left'
            verticalAlign='bottom'
            trigger={
              <button class={$.userMenuTrigger} type='button'>
                <img src={gravatarUrl} class={$.userpic} />
              </button>
            }
            class={$.authDropdown}
          >
            <div class={$.userMenu}>
              {company && (
                <>
                  <div class={clsx($.menuOption, $.menuOptionActive)}>
                    <span>{company.name}</span>
                  </div>
                  <hr class={$.menuDivider} />
                </>
              )}
              <Link to='/settings' class={$.menuOption} onClick={() => setMenuOpen(false)}>
                Настройки
              </Link>
              <button
                class={$.menuOption}
                type='button'
                onClick={() => {
                  logout()
                  setMenuOpen(false)
                }}
              >
                Выйти
              </button>
            </div>
          </Dropdown>
        </header>

        <div class={$.body}>
          <main class={$.content}>{children}</main>
          {sidecar && <aside class={$.sidecar}>{sidecar}</aside>}
        </div>

        <footer class={$.footer}>© 2026 ООО «Тандем Ритейл». Все права защищены.</footer>
      </div>
    </SidecarContext.Provider>
  )
}

function getGravatarUrl(email: string, size = 80) {
  let hash = md5(email.toLowerCase().trim())
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=identicon`
}
